<template>
  <div class="lazy-image">
    <img
      v-lazy="imageURL"
      :alt="imageTitle"
      :width="imageWidth"
      :height="imageHeight"
      :style="{
        maxWidth: imageMaxWidth,
        maxHeight: imageMaxHeight,
      }"
    />
    <div
      class="loading"
      :style="{
        top: loadingTop,
        left: loadingLeft,
      }"
    >
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lazyImage',
  props: [
    'imageURL',
    'imageTitle',
    'imageWidth',
    'imageHeight',
    'imageMaxWidth',
    'imageMaxHeight',
    'loadingTop',
    'loadingLeft',
  ],
};
</script>

<style scoped lang="scss">
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.lazy-image {
  position: relative;
  height: 100%;
  font-size: inherit;

  img[lazy='loading'] + .loading {
    display: block;
  }

  .loading {
    display: none;
    position: absolute;
    top: 0;
    left: 0;

    div {
      position: absolute;
      border: 4px solid #009eff;
      border-radius: 50%;
      opacity: 1;
      animation: lds-ripple 1.25s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }

    div:nth-child(2) {
      animation-delay: -0.5s;
    }
  }
}
</style>
